import ExternalServicePropertiesProvider from './ExternalServicePropertiesProvider';

const data = {
  __init__: [ 'externalServicePropertiesProvider' ],
  externalServicePropertiesProvider: [ 'type', ExternalServicePropertiesProvider ]
};

export default data;